import { FC, ReactElement } from 'react';
import classNames from 'classnames';

import { Stack } from '@mui/material';
import Modal from '~/ui/components/common/Modal';
import { IHospitalDetails } from '~/services/api/hospital/types';
import {
  getEmergencyContactAndInsuranceSection,
  getEventMetadata,
  getFacilityAndProviderSection,
  getMedicalInformationSection,
  getPatientInformationSection,
} from './utils';
import DetailsTitle from './DetailsTitle';
import DetailsTopPanel from './DetailsTopPanel';
import DetailsSection from './DetailsSection';
import DetailsFooter from './DetailsFooter';

import styles from './DetailsModal.module.scss';

export interface IProps {
  details: IHospitalDetails;
  onClose: () => void;
  onViewHistory?: (patientId: number, patientFullName: string) => void;
}

const DetailsModal: FC<IProps> = ({ details, onClose, onViewHistory }): ReactElement => {
  const { eventThemeClass, titleThemeClass, label } = getEventMetadata(details.eventId);

  return (
    <Modal
      open
      fullWidth
      maxWidth="md"
      title={<DetailsTitle eventLabel={label} />}
      titleClassName={classNames(styles.titleBar, styles[titleThemeClass])}
      className={classNames(styles.modal, styles[eventThemeClass])}
      footer={
        <DetailsFooter
          details={details}
          onClose={onClose}
          onViewHistory={() => onViewHistory?.(details.patientId, details.patientFullName)}
        />
      }
      onClose={onClose}
    >
      <Stack spacing={4} className={styles.container}>
        <DetailsTopPanel details={details} eventLabel={label} />

        <DetailsSection {...getPatientInformationSection(details)} />

        <DetailsSection {...getFacilityAndProviderSection(details)} />

        <DetailsSection {...getMedicalInformationSection(details)} />

        <DetailsSection {...getEmergencyContactAndInsuranceSection(details)} />
      </Stack>
    </Modal>
  );
};

export default DetailsModal;
